export default __webpack_public_path__ + "static/media/keto-bars.2b9bf813.png";